module.exports = __webpack_public_path__ + "img/macbook-air.62e1c8ea.svg";